/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientBipInfoModel } from '../../models/patient-bip-info-model';

export interface GetCurrentPatientBIPInfo$Params {
  patientID?: number;
}

export function GetCurrentPatientBIPInfo(http: HttpClient, rootUrl: string, params?: GetCurrentPatientBIPInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientBipInfoModel>> {
  const rb = new RequestBuilder(rootUrl, GetCurrentPatientBIPInfo.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientBipInfoModel>;
    })
  );
}

GetCurrentPatientBIPInfo.PATH = '/api/Staff/GetCurrentPatientBIPInfo';
